export const LeaseData = [
  {
    State: "FL",
    Rate: 0.14,
  },
  {
    State: "MA",
    Rate: 0.25,
  },
  {
    State: "CT",
    Rate: 0.25,
  },
  {
    State: "RI",
    Rate: 0.25,
  },
];
